import { APP_INITIALIZER, NgModule } from '@angular/core';

// modules
import { SharedModule } from './modules/shared.module';
import { AppRoutingModule } from './app.routing.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptor } from './interceptors/app.http.Interceptor';

// main
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { NavigationComponent } from './main/navigation/navigation.component';
import { HeaderComponent } from './main/header/header.component';
import { SidepanelComponent } from './main/sidepanel/sidepanel.component';
import { ErrorsComponent } from './main/errors/errors.component';
import { ErrorDialogComponent } from './main/errors/dialog/errorDialog.component';
import { ProjekteTreeComponent } from './main/navigation/projekte-tree/projekte-tree.component';
import { ArchivTreeComponent } from './main/navigation/archiv-tree/archiv-tree.component';
import { PlangebieteBarComponent } from './main/navigation/plangebiete-bar/plangebiete-bar.component';
import { AssistentBarComponent } from './main/navigation/assistent-bar/assistent-bar.component';
import { PagePanelComponent } from './components/page-panel/page-panel.component';
import { ElementPanelComponent } from "./components/element-panel/element-panel.component";
import { DialogComponent } from './components/dialog/dialog.component';
import { BottomSheetSaveCancelComponent } from './components/bottom-sheet-save-cancel/bottom-sheet-save-cancel.component';

// pages
import { ProjektListeComponent } from './pages/projekt-liste/projekt-liste.component';
import { ProjektDetailsComponent } from './pages/projekt-details/projekt-details.component';
import { ProjektAntragComponent } from './pages/projekt-antrag/projekt-antrag.component';
import { ProjektInfoComponent } from './pages/projekt-info/projekt-info.component';
import { BudgetArchivListeComponent } from './pages/budget-archiv-liste/budget-archiv-liste.component';
import { BudgetDashboardComponent } from './pages/budget-dashboard/budget-dashboard.component';
import { BudgetNeuComponent } from './pages/budget-neu/budget-neu.component';
import { BudgetKostenherleitungComponent } from './pages/budget-kostenherleitung/budget-kostenherleitung.component';
import { BudgetDetailsComponent } from './pages/budget-details/budget-details.component';
import { BudgetRisikenChancenComponent } from './pages/budget-risiken-chancen/budget-risiken-chancen.component';
import { BudgetFreigabeComponent } from './pages/budget-freigabe/budget-freigabe.component';
import { BudgetVerlaufComponent } from './pages/budget-verlauf/budget-verlauf.component';
import { BudgetBaunebenkostenComponent } from './pages/budget-baunebenkosten/budget-baunebenkosten.component';
import { HelpComponent } from './pages/help/help.component';
import { UnauthorizedComponent } from './authorization/unauthorized/unauthorized.component';
import { UnauthenticatedComponent } from './authorization/unauthenticated/unauthenticated.component';
import { ApplicationService } from './services/application.service';
import { GridService } from './services/controls/grid.service';
import { WirtschaftsplanErstellenComponent } from './pages/wirtschaftsplan-erstellen/wirtschaftsplan-erstellen.component';
import { BudgetFreigabeDialogComponent } from './pages/budget-freigabe-dialog/budget-freigabe-dialog.component';
import { BudgetPreissteigerungComponent } from './pages/budget-preissteigerung/budget-preissteigerung.component';
import { LOCALE_ID } from '@angular/core';
import { MsalModule, MsalService, MsalGuard, MsalInterceptor, ProtectedResourceScopes, MSAL_INSTANCE, MsalBroadcastService } from '@azure/msal-angular';
import { environment } from '../environments/environment'; //evauthorization/auth-config';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { BudgetTeilleistungenComponent } from './pages/budget-teilleistungen/budget-teilleistungen.component';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-licence';


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(environment);
}

const msalInterceptorConfig = {
  interactionType: InteractionType.Redirect as InteractionType.Redirect,
  protectedResourceMap: new Map<string, (string | ProtectedResourceScopes)[] | null>([])
};
const msalGuardConfig = {
  interactionType: InteractionType.Redirect as InteractionType.Redirect,
};

config({ licenseKey });

@NgModule({
  declarations: [
    AppComponent, 
    UnauthorizedComponent,
    UnauthenticatedComponent,
    MainComponent,
    PlangebieteBarComponent,
    NavigationComponent,
    ProjekteTreeComponent,
    ArchivTreeComponent,
    AssistentBarComponent,
    HeaderComponent,
    SidepanelComponent,
    ErrorsComponent,
    ErrorDialogComponent,
    PagePanelComponent,
    ElementPanelComponent,
    DialogComponent,
    BottomSheetSaveCancelComponent,
    ProjektListeComponent,
    ProjektDetailsComponent,
    ProjektAntragComponent,
    ProjektInfoComponent,
    BudgetArchivListeComponent,
    BudgetDashboardComponent,
    BudgetNeuComponent,
    BudgetBaunebenkostenComponent,
    BudgetTeilleistungenComponent,
    BudgetKostenherleitungComponent,
    BudgetDetailsComponent,
    BudgetRisikenChancenComponent,
    BudgetFreigabeComponent,
    BudgetVerlaufComponent,
    HelpComponent,
    WirtschaftsplanErstellenComponent,
    BudgetFreigabeDialogComponent,
    BudgetPreissteigerungComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    SharedModule,
    AppRoutingModule,
    MsalModule
  ],
   providers: [
    { provide: HTTP_INTERCEPTORS,  useClass: AppHttpInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS,  useClass: MsalInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'de-DE' }, // Setzt die allgemeine Locale für die Anwendung
    { provide: APP_INITIALIZER,
      multi: true,
      deps: [ApplicationService],
      useFactory: (appService: ApplicationService) => () => appService.init(),
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    MsalBroadcastService
  ],
})
export class AppModule { }
